import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Heading, Spinner, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAssetCatalogPaths } from '@/hooks/useAssetCatalogPaths'
import { CategoryForm } from '@/components/forms/CategoryForm'
import { useThemeColors } from '@/hooks/useThemeColors'
import { AssetCatalogShell } from '@/components/assetCatalog/AssetCatalogShell'

export default function CategoryEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { path } = useAssetCatalogPaths()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!numericId || Number.isNaN(numericId)) {
      navigate(path('categories'), { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [numericId, navigate])

  const handleDone = () => navigate(path('categories'))

  if (isValidating || !numericId) {
    return (
      <AssetCatalogShell fillHeight={false}>
        <Box p={4}>
          <Card>
            <CardBody display="flex" alignItems="center" justifyContent="center" minH="200px">
              <VStack spacing={4}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AssetCatalogShell>
    )
  }

  return (
    <AssetCatalogShell fillHeight={false}>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
      <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Category</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update this machine type
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <CategoryForm categoryId={numericId} onSuccess={handleDone} onCancel={handleDone} />
          </CardBody>
        </Card>
      </Box>
      </Box>
    </AssetCatalogShell>
  )
}
